<template>
  <div class="flex h-screen flex-wrap justify-center frontend">
    <div class="wx-row">
      <div class="wx-col w-100">
        <div class="logo">
          <img
            src="https://www.fsm.edu.tr/mainSite/assets/images/logo@2x-yeni.png"
            alt="graphic"
            class="mx-auto logo-img cursor-pointer"
            ref="fsmLogo"
            style="height:100px;width:181px;"
            @click="goToHome()"
          />
        </div>
      </div>
    </div>
    <router-view />
    <div class="flex lg:flex-col w-100 justify-center self-end">
      <Copyright />
    </div>
  </div>
</template>

<script>
import Copyright from "@/views/components/Copyright";

export default {
  components: {
    Copyright,
  },
  methods: {
    goToHome() {
      let formName = "";

      if (this.$auth.isAuthenticated())
        formName = this.$store.getters["auth/getLoginGroup"];

      if (!this.$route.query.form)
      this.$misc.emit("formGroupEvent", formName);
    },
  },
};
</script>
